module.exports = __webpack_public_path__ + "static/media/third-party.a1f99ed6.svg";